<template>
    <div :style="{height: containerHeight}" style="overflow-y: hidden; left: 50%; transform: translateX(-50%);" class="relative">
        <div class="absolute" style="width: 100%">
            <div ref="image" class="relative">
                <div class="absolute text-gray-400 overflow-hidden whitespace-nowrap"
                     style="bottom: 45%; width: 65%; left: 22%; text-overflow: ellipsis; font-size: 13px;">
                    {{ displayName }}
                </div>

                <img ref="image" src="/images/connected_devices.png" alt="Connected devices">
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    props: {
        displayName: String
    },
    data() {
        return {
            containerHeight: '255px'
        }
    },
    mounted() {
        this.containerHeight = `${this.$refs.image.clientWidth}px`

        console.log(this.$refs.image.clientWidth, this.$refs.image.clientHeight)
    }
}

</script>